export default {
  picker: {
    cancel: 'キャンセル',
    confirm: '確認',
  },
};
